import { gql } from '@apollo/client';

export const ARCHIVE_COHORT = gql`
  mutation ArchiveCohort($id: ID!) {
    cohort: archiveCohort(id: $id) {
      id
      name
    }
  }
`;
